FiltersMdl.service( 'FamiliesSrv', ['$http', '$q', 'API_URL', function ( $http, $q, API_URL ) {

	var families = null;


	return {

		/**
		 * Get all hues families.
		 * Singleton.
		 * @returns {*}
		 */
		getFamilies: function() {
			var deffered = $q.defer();
			if ( families )
				deffered.resolve( families );
			else{
				$http.get( API_URL.FILTER + '/family/hue').then(
					function (response){
						families = response.data;
						deffered.resolve( families );
					},
					function (error){
						deffered.reject(error);
					}
				)
			}
			return deffered.promise;
		},
	}
}]);

